import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { cn } from '@/utils/utils';

export interface NarrativeTabOption {
  labelKey: string;
  value: string;
}

interface NarrativeTabsProps {
  className?: string;
  onChange: (value: string) => void;
  options: Array<NarrativeTabOption>;
  value: string;
}

export function NarrativeTabs({ className, onChange, options, value }: NarrativeTabsProps) {
  const { t } = useTranslation();
  return (
    <div className={cn('w-full', className)}>
      <div className="flex items-center gap-2 px-3 pb-2">
        {options.map((option) => {
          const isActive = value === option.value;
          return (
            <Button
              className={cn(
                'flex h-[28px] flex-1 items-center justify-center rounded-[6px] px-[10px] py-[6px] text-center font-normal shadow-none transition-all',
                'font-sans text-[14px] leading-[170%]',
                isActive
                  ? 'bg-primary text-primary-foreground hover:bg-primary! hover:text-primary-foreground!'
                  : 'bg-transparent text-foreground hover:bg-transparent! hover:text-foreground!',
              )}
              key={option.value}
              onClick={() => onChange(option.value)}
              variant="ghost"
            >
              {t(option.labelKey)}
            </Button>
          );
        })}
      </div>
      <div className="px-3">
        <div className="border-border-subtle border-b" />
      </div>
    </div>
  );
}
